import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Login from './pages/Login';
import ParentAppGate from './components/ParentAppGate';
import SelectSchool from './pages/SelectSchool';
import Dashboard from './pages/Dashboard';
import Students from './pages/Students';
import DispersalAtGate from './pages/DispersalAtGate';
import DispersalEarly from './pages/DispersalEarly';
import DispersalStatus from './pages/DispersalStatus';
import Profile from './pages/Profile';
import { authService, ErrorBoundary } from '@uniqcamp/shared';
import { SelectedSchoolProvider } from './contexts/SelectedSchoolContext';
import { theme } from './theme';
import SchoolPortalApiListener from './components/SchoolPortalApiListener';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});

function PrivateRoute(props: { children: React.ReactNode }) {
  const ok = authService.isAuthenticated() && authService.getStoredUser()?.role === 'PARENT';
  if (!ok) return <Navigate to="/login" replace />;
  return <>{props.children}</>;
}

function App() {
  return (
    <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SchoolPortalApiListener />
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<PrivateRoute><SelectedSchoolProvider><ParentAppGate /></SelectedSchoolProvider></PrivateRoute>}>
              <Route path="select-school" element={<SelectSchool />} />
              <Route index element={<Dashboard />} />
              <Route path="students" element={<Students />} />
              <Route path="dispersals" element={<Navigate to="/dispersals/at-gate" replace />} />
              <Route path="dispersals/at-gate" element={<DispersalAtGate />} />
              <Route path="dispersals/early" element={<DispersalEarly />} />
              <Route path="dispersals/status" element={<DispersalStatus />} />
              <Route path="profile" element={<Profile />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
